import old_pages from './ru-old-admin-pages';

const messages = {
  old_pages : old_pages,
  unnamed: '--без имени--',
  id: 'ID',
  one: 'Один',
  all: '--Все--',
  pieces: 'шт.',
  placeholder_hm: 'ЧЧ:ММ',
  placeholder_hms: 'ЧЧ:ММ:CC',
  filter: 'Фильтры',
  filter_additional: 'Дополнительные фильтры',
  filter_hide: 'скрыть фильтр',
  filter_clear: 'Очистить фильтры',
  group_settings: 'Настройки группы',
  search: 'Поиск',
  create: 'Создать',
  add: 'Добавить',
  save: 'Сохранить',
  back_to_list: 'Назад к списку',
  remove: 'Удалить',
  apply: 'Применить',
  export: 'Экспорт',
  import: 'Импорт',
  download: 'Скачать',
  upload: 'Загрузить',
  cancel: 'Отменить',
  confirm: 'ОК',
  logout: 'Выход',
  sync_caches: 'Синхр. кэши',
  sync_templates: 'Синхр. шаблоны',
  resend: 'Переотправить',
  back: 'Назад',
  display_charts: 'Отображать графики',
  attach: 'Прикрепить',
  tableEmpty: 'Задайте параметры поиска <br> для получения выдачи',
  contentEmpty: 'Шаблоны по выбранному транспорту отсутствуют',
  browserNotSupport: 'Данный браузер не поддерживается',
  base_settings:'Основные настройки',
  additional_settings:'Дополнительные настройки',
  cascading:'Каскадирование',
  scheduler:'Планировщик',
  smpp_settings: 'Настройки SMPP аккаунта',
  http_settings: 'Настройки HTTP аккаунта',
  allowed_operators: 'Разрешенные поставщики услуг',
  new_originator: 'Новый адрес отправителя',
  originator: 'Адрес отправителя',
  originator_id: 'Адрес отправителя',
  transport: 'Транспорт',
  service_provider: 'Поставщик услуг',
  partner: 'Клиент',
  description: 'Описание',
  description_regex: 'Описание регулярного выражения',
  commentary: 'Комментарий',
  status: 'Статус',
  login: 'Логин',
  email: 'Электронная почта',
  password: 'Пароль',
  confirm_password: 'Подтвердить пароль',
  protocol: 'Протокол',
  name: 'Название',
  message_type: 'Тип сообщения',
  value: 'Значение',
  system_setting: 'Переменная настройки системы',
  account: 'Аккаунт',
  account_id: 'Аккаунт',
  template: 'Шаблон',
  rule: 'Правило',
  broker_account: 'Аккаунт',
  connection_type: 'Тип соединения',
  connection_duration: 'Длительность подключения',
  pool: 'Пул',
  text: 'Текст',
  condition: 'Условие',
  transports: 'Транспорт',
  regex: 'Регулярное выражение',
  regex_rule_delete: 'Удалить регулярное выражение',
  is_default: 'Категория по умолчанию',
  message_category: 'Категория сообщения',
  is_default_sms: 'Категория по умолчанию SMS',
  is_default_viber: 'Категория по умолчанию Viber',
  is_default_whatsapp: 'Категория по умолчанию WhatsApp',
  1: 'Да',
  0: 'Нет',
  price: 'Цена',
  default_price: 'Цена по умолчанию',
  tarification: 'Тарификация',
  tarification_by_category: 'Тарификация по категориям',
  price_by_category: 'Цена отправки по категории',
  select_address: 'Задать адрес для подмены:',
  select_pool: 'Выбрать пул',
  account_name: 'Имя аккаунта',
  push_statuses: 'Автоматическое получение статусов доставки',
  status_report: 'Сообщать о статусах',
  max_throughput: 'Максимальная пропускная способность',
  immediate_response_needed: 'Сразу возвращать submit_sm_resp',
  for_all: 'Всех',
  final: 'Финальных',
  new_sender_address: 'Новый адрес отправителя',
  prepaid: 'Авансовая схема взаиморасчетов',
  multisignature: 'Мультиподпись',
  template_only: 'Только шаблон',
  moderation: 'Модерация',
  report_create_date: 'Дата создания отчета',
  report_finish_date: 'Дата завершения формирования отчета',
  choose_partner: 'Выберите клиента',
  choose_transport: 'Выберите транспорт',
  choose_template: 'Выберите шаблон',
  server: 'Сервер',
  connection_name: 'Название соединения',
  status_duration: 'Длительность статуса',
  messages_in_queue: 'Сообщений в очереди',
  delivered_messages: 'Доставлено, %',
  mt_per_min: 'Исходящих в минуту',
  mo_per_min: 'Входящих в минуту',
  connection_status: 'Статус соединения',
  server_name: 'Название сервера',
  current_status_duration: 'Длительность нахождения соединения в текущем статусе',
  messages_in_queue_tooltip: 'Количество сообщений в очереди',
  delivered_messages_tooltip: 'Количество доставленных сообщений',
  mt_per_min_tooltip: 'Количество исходящих сообщений в минуту',
  mo_per_min_tooltip: 'Количество входящих сообщений в минуту',
  newTemplate: 'Новый шаблон',
  button_link: 'Ссылка для перехода',
  partner_user: 'Пользователь',
  sender: 'Отправитель',
  message: 'Сообщение',
  priority: 'Приоритет',
  rules_order_by_priority: 'Приоритет правил',
  active: 'Активность',
  ttl: 'Срок жизни сообщения (с)',
  blacklist: 'Черный список',
  sending_speed: 'Скорость отправки в секунду',
  message_length: 'Длина сообщения',
  statistic: 'Отображать текст в статистике',
  use_cascading: 'Использовать каскадирование',
  channel: 'Канал доставки',
  channel_id: 'Транспорт',
  multichannel_chanel: 'Канал',
  multichannel_template_name: 'Шаблон',
  multichannel_timeout: 'Таймаут',
  tooltip_timeout: 'Время в формате ЧЧ:ММ:СС, через которое будет осуществлена отправка по альтернативному каналу',
  send_date: 'Дата отправки',
  send_time: 'Время отправки',
  allowed_days: 'Дни для отправки',
  send_evenly: 'Равномерно распределять рассылку',
  translit: 'Транслитерация',
  char_entered: 'Введено символов',
  variables: 'Переменные',
  total: 'Итого',
  originator_restrictions: 'Разрешенные отправители',
  date: 'Дата',
  date_from: 'Дата с',
  date_to: 'Дата по',
  event_date: 'Дата',
  group_by: 'Группировать по ',
  group_by_optionally: 'Дополнительно группировать по ',
  sent_date_from: 'Дата отправки с',
  sent_date_to: 'Дата отправки по',
  deliver_date_from: 'Дата доставки с',
  deliver_date_to: 'Дата доставки по',
  defer_date: 'Дата отложенной отправки',
  sent_date: 'Дата отправки',
  recipient: 'Абонент',
  recipient_country: 'Страна',
  country: 'Страна',
  recipient_region: 'Регион',
  receiver: 'Получатель',
  message_parts: 'Количество частей сообщений',
  error_code: 'Код ошибки',
  error_description: 'Описание ошибки',
  template_id: 'ID шаблона',
  bulk_id: 'ID рассылки',
  operator: 'Оператор',
  mcc: 'MCC',
  mnc: 'MNC',
  broker_account_login: 'Аккаунт брокера',
  partner_login: 'Пользователь личного кабинета',
  smpp_message_id: 'SMPP ID',
  smpp_connection: 'SMPP-коннект',
  external_id: 'ID во внешней системе',
  create_date: 'Дата создания',
  postponed_date: 'Дата отложенной отправки',
  delivery_date: 'Дата доставки',
  source_type: 'Тип источника',
  parent_message_id: 'ID родительского сообщения',
  parent_message_channel: 'Канал родительского сообщения',
  detail: 'Подробно',
  price_for_partner: 'Цена для клиента',
  price_from_provider: 'Цена от поставщика услуг',
  ext_id1: 'Ext_ID 1',
  ext_id2: 'Ext_ID 2',
  ext_id3: 'Ext_ID 3',
  ext_id4: 'Ext_ID 4',
  ext_id5: 'Ext_ID 5',
  service_number: 'Номер',
  service_no: 'Сервисный номер',
  originator_operator: 'Оператор',
  originator_country: 'Страна',
  message_segments: 'Количество сегментов SMS сообщения',
  transmitted: 'Отправлено',
  delivered: 'Доставлено',
  not_delivered: 'Не доставлено',
  expired: 'Просрочено',
  failed: 'Ошибка',
  error: 'Ошибка',
  rejected: 'Отклонено',
  deferred: 'Отложено',
  transmitted_parts: 'Отправлено (частей)',
  delivered_parts: 'Доставлено (частей)',
  not_delivered_parts: 'Не доставлено (частей)',
  expired_parts: 'Просрочено (частей)',
  failed_parts: 'Ошибка (частей)',
  error_parts: 'Ошибка (частей)',
  rejected_parts: 'Отклонено (частей)',
  deferred_parts: 'Отложено (частей)',
  total_parts: 'Итого (частей)',
  inAll: 'Всего',
  income: 'Доход',
  rate: 'Расход',
  transmitted_tooltip: 'Сообщения были переданы оператору, но статус о доставке еще не получен',
  delivered_tooltip: 'Сообщения были доставлены до абонента',
  not_delivered_tooltip: 'Сообщения не были доставлены до абонента. Финальный статус',
  expired_tooltip: 'Сообщения были переданы оператору, их срок жизни истек в очереди оператора',
  failed_tooltip: 'При попытке отправки сообщения возникла ошибка',
  rejected_tooltip: 'Сообщения были отклонены платформой',
  deferred_tooltip: 'Сообщения будут отправлены позже',
  total_tooltip: 'Общее число сообщений',
  partner_price_tooltip: 'Цена для клиента',
  provider_price_tooltip: 'Цена от поставщика услуг',
  start_date: 'Дата начала звонка',
  end_date: 'Дата завершения звонка',
  start_date_from: 'Дата создания с',
  start_date_to: 'Дата создания по',
  end_date_from: 'Дата доставки с',
  end_date_to: 'Дата доставки по',
  content: 'Контент',
  call_duration: 'Длительность звонка',
  module: 'Модуль',
  incoming_number: 'Входящий номер',
  finished: 'Завершено',
  not_answered: 'Не отвечено',
  buffered: 'Отложено',
  duration: 'Длительность',
  partner_price: 'Цена клиента',
  provider_price: 'Цена поставщика услуг',
  subject: 'Тема письма',
  message_text: 'Текст письма',
  show_message_text: 'Показать текст письма',
  message_text_empty: 'Текст письма не задан',
  empty: 'Пусто',
  read_date: 'Дата прочтения',
  read: 'Прочитано',
  read_tooltip: 'Сообщения были прочитаны',
  price_for_provider: 'Цена для поставщика услуг',
  email_from: 'От кого',
  attaches: 'Файлы вложений',
  application: 'Приложение',
  platform: 'Платформа',
  device: 'Устройство',
  title: 'Заголовок',
  content_load_date: 'Дата загрузки контента',
  choose_application: 'Выберите приложение',
  settings_fcm: 'Настройки FCM',
  settings_apns: 'Настройки APNS',
  settings_hms: 'Настройки HMS',
  settings_xiaomi: 'Настройки Xiaomi',
  settings_dp: 'Настройки Direct PUSH',
  settings_dp2: 'Настройки Direct PUSH 2',
  type: 'Тип',
  devices_policy: 'Устройства',
  check_sign: 'Проверять подпись для запросов к MobileApi',
  connection_count: 'Количество соединений',
  android_count: 'Android',
  ios_count: 'iOS',
  total_count: 'Всего',
  subscribed: 'Подписано',
  unsubscribed: 'Отписано',
  pic_link: 'Ссылка на изображение',
  button_name: 'Название кнопки',
  link_button: 'Ссылка на кнопку',
  postponed_message_date: 'Дата отложенной отправки',
  expire_date: 'Дата окончания срока жизни',
  viber_message_id: 'Viber ID',
  image: 'Изображение',
  image_link: 'Ссылка на изображение',
  upload_file_description: 'Перетащите файл на страницу или нажмите кнопку загрузить',
  btn_link: 'Ссылка кнопки',
  read_subscriber_tooltip: 'Сообщения были прочитаны абонентом',
  push_message_id: 'Push ID',
  whatsapp_message_id: 'WhatsApp ID',
  first_name: 'Имя',
  mail: 'Почта',
  timezone: 'Часовой пояс',
  show_messages_text: 'Отображать тексты сообщений',
  is_check_pass: 'Сменить пароль при следующей авторизации',
  show_finance_info: 'Показывать финансовую информацию',
  role: 'Роль',
  role_use: 'Использовать роль',
  role_settings: 'Настройки роли',
  access_settings: 'Настройки доступа',
  without_role: '--Без роли--',
  topic: 'Тема',
  from_whom: 'От кого',
  user_pages: 'Страницы',
  allow: 'Разрешить',
  deny: 'Отклонить',
  on_moderation: 'Взять на модерацию',
  edit_date: 'Дата редактирования',
  select_reason: 'Укажите причину',
  recipients_count: 'Количество получателей',
  action_date: 'Дата',
  action_user: 'Пользователь',
  action_page: 'Страница',
  action_source: 'Интерфейс платформы',
  object_type: 'Тип объекта',
  object_name: 'Название объекта',
  action: 'Действие',
  ip_address: 'IP-адрес пользователя',
  additional_info: 'Дополнительная информация',
  action_source_admin: 'Интерфейс администратора',
  action_source_lk: 'Личный кабинет',
  system_actions: 'Логируемые действия',
  success: 'Успешно',
  select_action_source: 'Выберите интерфейс платформы',
  detail_info: 'Информация о сообщении',
  detail_incoming: 'Детальная статистика входящих',
  group: 'Групповая статистика',
  group_incoming: 'Групповая статистика входящих',
  originators: 'Адреса отправителей',
  partners: 'Клиенты',
  partner_id: 'Клиент',
  quantity: 'Количество',
  service_providers: 'Поставщики услуг',
  templates: 'Шаблоны',
  templates_new: 'Создание шаблона',
  templates_edit: 'Редактирование шаблона',
  timeout: 'Таймаут',
  message_limit: 'Количество сообщений',
  regexp: 'Регулярное выражение',
  access: 'Доступ',
  service_providers_empty: 'Поставщики услуг не заданы',
  not_selected_service_providers: 'Не выбран ни один поставщик услуг',
  priority_exist: 'Запись с выбранным приоритетом уже существует',
  priority_more_zero: 'Приоритет должен быть больше 0',
  choose_client: 'Выберите клиента',
  choose_role: 'Выберите роль',
  sections: 'Разделы',
  amount: 'Сумма',
  source: 'Источник',
  balance: 'Баланс',
  overdraft: 'Порог отключения',
  helper_overdraft: 'При достижении данного порога клиенту будет запрещено отправлять сообщения по любому из подключенных каналов',
  setup_overdraft: 'Настроить порог отключения',
  top_up_balance: 'Пополнить баланс',
  top_up: 'Пополнить',
  displayed_balances_version: 'Отображены балансы на текущую дату ',
  administrator: 'Администратор',
  balance_completed: 'Баланс успешно пополнен',
  resend_message: 'Переотправить сообщение',
  number_subscriptions: 'Количество подписок',
  number_subscriptions_day: 'Количество подписок по дню',
  number_contacts:'Количество контактов',
  delete_contact: 'Удалить контакт(ы)',
  separator: 'Разделитель',
  file: 'Файл',
  addresser: 'Отправитель',
  user_parameters: 'Пользовательские параметры',
  custom_message_id: 'Custom ID',
  emailAttachedFilesSizeLimit: 'Не удалось прикрепить файл {filename} - размер файлов аттачей превышает 25 мегабайт',
  processed: 'Обработано',
  use_proxy: 'Использовать прокси',
  hostname: 'Сервер',
  port: 'Порт',
  access_denied: "Доступ к странице запрещен",
  ad_group_name: 'Группа пользователей Active Directory',
  mn_service: "Сервис Mail Notify",
  mn_template: "Шаблон Mail Notify",
  mn_routes: 'Список соц.сетей для отправки',
  vk_message: 'Текст сообщения для VK',
  ok_message: 'Текст сообщения для OK',
  os: 'ОС',
  owner: 'Владелец',
  cloud: 'Облако',
  operating_system: 'Операционная система',
  app_version: 'Версия приложения',
  os_version: 'Версия ОС',
  sdk_version: 'Версия SDK',
  check_contacts_uniqueness: 'Проверять контакты на уникальность',
  check_duplicates_policy: 'Параметры проверки на уникальность',
  check_with_msisdn: 'Проверять по msisdn',
  check_with_email: 'Проверять по email',
  check_with_msisdn_email: 'Проверять по msisdn и email',
  file_only: 'Только файл',
  file_and_group: 'Файл и группа',
  page_size: 'Размер страницы',
  page_number: 'Номер страницы',
  order_by: 'Сортировать по',
  order_direction: 'Направление сортировки',
  message_direction: 'Направление сообщения',
  message_id: 'ID сообщения',
  import_success: 'Импорт успешно завершен',
  import_error: 'Ошибка импорта',
  invalid_file: 'Некорректный файл',
  added_zones_count: 'Тарифных зон добавлено',
  edited_zones_count: 'Тарифных зон изменено',
  failed_zones_count: 'Тарифных зон не добавлено',
  black_list: 'Чёрный список',
  general: 'Общий',
  number: 'Количество',
  widget_type: 'Тип виджета',
  reason: 'Причина',
  reset_password: 'Сбросить пароль',
  old_role_id: "Предыдущая роль",
  new_role_id: "Новая роль",
  cascading_delivered_messages: "Каскадирование доставленных сообщений",
  tooltip_delivered_messages: "Активатор отправки по альтернативному каналу при позитивных статусах сообщений. </br>" +
      "• Если переключатель активирован, то отправка по альтернативному каналу будет осуществлена, независимо от того было ли доставлено исходное сообщение.</br>" +
      "• Если переключатель деактивирован, то отправка по альтернативному каналу будет выполнена только при недоставке исходного сообщения.",
  delivery_type: "Способ отправки",
  send_web_push: "Отправка WEB PUSH",
  settings_seng_web_push: "Настройка по отправке WEB PUSH",
  public_key: "Публичный ключ",
  private_key: "Приватный ключ",
  sender_signature: "Подпись отправителя",
  applications: 'Приложения',
  app_groups: 'Группы приложений',
  app_by_date: 'Выбор по дате создания',
  app_by_date_tooltip: 'Выбор приложения по дате создания. Если выбрано Все, то отправка уведомления будет осуществлена во все\n' +
      '                  выбранные приложения. Если выбрано Последнее созданное, то отправка уведомления будет осуществлена\n' +
      '                  только в последнее созданное приложение. В выборке участвуют только те приложения, на которые подписан\n' +
      '                  получатель.',
  group_selection_rule: 'Правило выбора группы',
  group_selection_rule_tooltip: 'Правило выбора группы приложений. Если выбрано Все, то осуществляется выбор всех групп для отправки.\n' +
      '                  Если выбрано По приоритету, то осуществляется выбор самой приоритетной группы для отправки. В выборке\n' +
      '                  участвуют только те группы, в которых есть хотя бы одно приложение, на которое подписан получатель.',
  app_selection_rule: 'Правило выбора приложения',
  app_selection_rule_tooltip: 'Правило выбора приложения. Если выбрано Все, то осуществляется выбор всех приложений группы для\n' +
      '                  отправки. Если выбрано По приоритету, то осуществляется выбор самого приоритетного приложения группы\n' +
      '                  для отправки. Если выбрано Последнее созданное, то осуществляется выбор последнего созданного\n' +
      '                  приложения группы для отправки. В выборке участвуют только те приложения, на которые подписан\n' +
      '                  получатель.',
  sublist_settings: 'Настройки подписок',
  sublist_app_by_date_tooltip: 'Выбор подписки по дате создания. Если выбрано Все, то отправка уведомления будет осуществлена на все подписки приложений. Если выбрано Последняя созданная, то отправка уведомления будет осуществлена только на последнюю созданную подписку приложений.',
  push_application: 'Push-приложения',
  push_applications_groups_priority: 'Приоритет групп push-приложений',
  additional_params: 'Дополнительные параметры шаблона',
  key: 'Ключ',
  value_settings: "Настройки значения",
  min_length: "Мин. длина",
  max_length: "Макс. длина",
  min_value: "Мин",
  max_value: "Макс",
  limitations: "Ограничения",
  link: "Ссылка",

  auth:{
    title: 'Консоль администратора',
    description: 'Авторизация',
    changing_title: 'Согласно политике безопасности Вам нужно сменить пароль',
    button: 'Войти',
    back: 'На страницу авторизации',
    change_password: 'Сменить пароль',
    language:'Язык интерфейса',
    email:'Электронная почта',
    password:'Пароль',
    new_password:'Новый пароль',
    confirm_new_password:'Подтвердите новый пароль',
    login: 'Электронная почта / Логин AD',
  },

  system_settings:{
    ADMIN_LOGS_STORAGE_TIME: 'Период хранения логов в днях',
    BROKER_MESSAGES_STORAGE_TIME: 'Срок хранения статистики для BROKER_MESSAGES',
    CALL_ALLOWED_OP: 'Отправка звонков через операторов. Возможные значения: ALL - через любых; Оператор1; Оператор2 - через разрешенных, где Оператор1 и Оператор2 имена поставщиков услуг',
    CALL_ROUTING: 'Тип маршрутизации звонков. Возможные значения: MCC/MNC - по MCC/MNC; MSISDN - по префиксу MSISDN',
    CALL_STORAGE_TIME: 'Срок хранения статистики для CALL',
    CALL_TARIFF: 'Тип тарификации звонков. Возможные значения: SEC - за секунду; MIN - за минуту',
    DEFAULT_TZ: 'Часовой пояс по умолчанию. Возможные значения от -11 до 12',
    EMAIL_STORAGE_TIME: 'Срок хранения статистики для EMAIL',
    LOG_ACTIONS: 'Логируемые действия. Возможные значения: 1 - чтение; 2 - создание; 3 - редактирование; 4 - удаление; 5 - отправка;. Значения задаются через запятую - 1,2,3,4,5',
    MAX_AUTH_ATTEMPTS: 'Максимальное количество неудачных авторизаций пользователя, выполненных подряд. При превышении максимального количества, аккаунт пользователя деактивируется. Если = 0, ограничений нет',
    PASSWORDS_STORAGE_QUANTITY: 'Количество сохраняемых старых паролей пользователей системы и личного кабинета. Если = 0, старые пароли не сохраняются',
    PASSWORDS_VALIDITY_PERIOD: 'Максимальный срок жизни паролей пользователей системы и личного кабинета в днях. Если = 0, ограничений нет',
    PUSH_STORAGE_TIME: 'Срок хранения статистики для PUSH',
    REPORTS_COUNT: 'Количество одновременных выгрузок отчетов в системе',
    SMS_ALLOWED_OP: 'Отправка SMS через операторов. Возможные значения: ALL - через любых; Оператор1; Оператор2 - через разрешенных, где Оператор1 и Оператор2 имена поставщиков услуг',
    SMS_BLOCK_PRIORITY: 'Список приоритетов, для которых требуется блокировка SMS. Возможные значения: 2 - Low; 4 - Medium; 6 - High; 8 - Realtime; Значения задаются через запятую - 2,4,6,8',
    SMS_ROUTING: 'Тип маршрутизации SMS. Возможные значения: MCC/MNC - по MCC/MNC; MSISDN - по префиксу MSISDN',
    SMS_STORAGE_TIME: 'Срок хранения статистики для SMS',
    SMS_TARIFF: 'Тип тарификации SMS. Возможные значения: D - за доставку; SENDING - за отправку',
    STAT_DATE_OFFSET: 'Максимальное количество дней для вывода в отчетах',
    UNDELIVERED_SMS_COUNT: 'Количество подряд недоставленных SMS абоненту для блокировки дальнейшей отправки. Возможные значения: 0 - блокировка отключена; N - блокировка при N подряд недоставленных SMS, где N - целое положительное число больше нуля',
    UNDELIVERED_SMS_PERIOD: 'Минимальное количество дней, за которые абоненту должно быть UNDELIVERED_SMS_COUNT недоставленных SMS для блокировки. Возможные значения: 0 - минимальный период не задан; N - минимальный период равный N дням, где N - целое положительное число больше нуля',
    VIBER_STORAGE_TIME: 'Срок хранения статистики для VIBER',
    IVR_PREFIX_URL: 'Префикс ссылки для получения аудио файлов в WCS',
    MAX_WIDGETS_NUM: 'Максимальное количество отображаемых виджетов',
    USERS_TEMPORARY_BLOCKING_TIMEOUT: 'Срок временной блокировки учётных записей Интерфейса администратора и Личного кабинета (в минутах)',
    USERS_SYSTEM_BLOCKING_TIMEOUT: 'Срок неактивности учётных записей Интерфейса администратора и Личного кабинета (в днях), по истечении которого происходит автоматическая блокировка',
    PASSWORDS_DIFFERENCE_SYMBOLS_NUMBER: 'Минимальное количество символов, на которые новый пароль должен отличаться от последнего',
    PASSWORDS_MINIMAL_LENGTH: 'Минимальная длина пароля',
    PUSH_DEFERRED_DELAY_BEFORE_ALL: 'Задержка перед отправкой отложенного push-уведомления на устройство в процентах от разницы между запланированным временем отправки и временем создания рассылки',
    PUSH_DEFERRED_DELAY_BEFORE_ANDROID: 'Задержка для платформы Android перед отправкой отложенного пуша на устройство в процентах от разницы между запланированным временем отправки и временем создания рассылки',
    PUSH_DEFERRED_DELAY_BEFORE_IOS: 'Задержка для платформы iOS перед отправкой отложенного пуша на устройство в процентах от разницы между запланированным временем отправки и временем создания рассылки',
    PUSH_DEFERRED_DELAY_BEFORE_HUAWEI: 'Задержка для платформы Huawei перед отправкой отложенного пуша на устройство в процентах от разницы между запланированным временем отправки и временем создания рассылки',
    PUSH_DEFERRED_DELAY_BEFORE_XIAOMI: 'Задержка для платформы Xiaomi перед отправкой отложенного пуша на устройство в процентах от разницы между запланированным временем отправки и временем создания рассылки',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_ALL: 'Минимальная задержка для всех платформ перед отправкой отложенного пуша на устройство в часах',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_ANDROID: 'Минимальная задержка для платформы Android перед отправкой отложенного пуша на устройство в часах',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_IOS: 'Минимальная задержка для платформы iOS перед отправкой отложенного пуша на устройство в часах',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_HUAWEI: 'Минимальная задержка для платформы Huawei перед отправкой отложенного пуша на устройство в часах',
    PUSH_DEFERRED_MIN_DELAY_BEFORE_XIAOMI: 'Минимальная задержка для платформы Xiaomi перед отправкой отложенного пуша на устройство в часах',
    AUTHORIZATION_TYPE: 'Способ авторизации в системе. Возможные значения: 1 - через логин/пароль Рассылочной Платформы; 2 - через логин/пароль Active Directory; 3 - оба способа',
    ACTIVE_DIRECTORY_URL: 'Строка подключения к Active Directory',
    ACTIVE_DIRECTORY_DOMAIN: 'Имя домена Active Directory',
    ACTIVE_DIRECTORY_DEFAULT_PARTNER_ID: 'Идентификатор клиента, доступ к транспортам которого получают по умолчанию пользователи Личного кабинета, авторизующиеся через Active Directory',
    ACTIVE_DIRECTORY_REQUEST_TIMEOUT: 'Тайм-аут ожидания (в секундах) ответа от сервера Active Directory',
    ATTACHMENT_SIZE_LIMIT_EMAIL: 'Ограничение размера вложения email',
    DEFAULT_PAGE_SIZE: 'Количество сообщений в одной пачке по умолчанию',
    MAX_RESEND_MESSAGES_NUM: 'Максимальное количество переотправляемых сообщений',
    DISTRIBUTION_MODERATION_POLICY: 'Условие модерации рассылок',
    CRM_ALLOWED_TEMPLATES_MESSAGE_TYPES: 'Разрешенные типы сообщений для шаблонов для отправки в CRM',
    EMAIL_VERIFY_TEMPLATE_ID: 'Идентификатор шаблона для отправки кода подтверждения email',
    SELFREGISTRATION_ACTIVATION: 'Флаг активации самостоятельной регистрации пользователя интерфейса',
    IMPORT_FILE_ROWS_LIMIT: 'Максимальное количество записей в импортируемом файле',
    BLACKLIST_DUPLICATE_POLICY: 'Политика проверки дубликатов в общем чёрном списке. Возможные значения: 0 – параметры не проверяются, 1 – проверяется только msisdn, 2 – проверяется только email, 3 – проверяются msisdn и email',
    PASSWORD_RESET_ATTEMPTS_TIME_LIMIT: 'Ограничение по времени между попытками сброса пароля пользователя личного кабинета. Задается в минутах.',
    USE_CAPTCHA_FOR_PASSWORD_RESET: 'Флаг использования captcha при сброса пароля',
    CHANGE_PASSWORD_TEMPLATE_ID: 'Идентификатор шаблона для отправки ссылки сброса пароля'
  },

  errors: {
    internal: 'Внутренняя ошибка сервера.',
    validation: 'Ошибка валидации.',
    violation: 'Запись с идентичным(и) параметром(aми) уже существует.',
    rule_must_be_unique: "Правила не должны повторяться",
    invalid_length_field: 'Длина {field} должна составлять 2 или 3 символа',
    category_not_deleted:'Невозможно удалить категорию.<br>Нельзя автоматически перенастроить тарифные зоны (тарифы).',
    dependent_transport:'Невозможно деактивировать транспорт так как есть зависимые записи.',
    not_found: 'Запись не найдена.',
    invalid_credentials: 'Невозможно авторизоваться.<br>Неправильный логин/пароль.',
    user_locked: 'Невозможно авторизоваться.<br>Ваш аккаунт заблокирован.',
    incorrect_password: 'Невозможно сменить пароль.<br>Данный пароль уже использовался.',
    mandatory_parameters:'Отсутствуют обязательные параметры или ошибка синтаксиса запроса.',
    client_denied_transport: 'Невозможно активировать аккаунт.<br>Клиенту не разрешен выбранный канал.',
    client_locked: 'Невозможно активировать аккаунт.<br>Клиент заблокирован.',
    unauthorized: 'Ошибка доступа.',
    main_reserve_filled: 'У поставщика услуг уже заполнен основной и резервный модуль.',
    overlapping_conditions: 'Невозможно сохранить правило.<br>Содержит пересечение с существующими правилами.',
    max_widgets_num: 'Невозможно добавить новый виджет.<br>Превышен лимит виджетов.',
    password_difference_symbols: 'Невозможно сменить пароль.<br>Новый пароль должен отличаться от предыдущего не менее чем на',
    password_length: 'Невозможно сменить пароль.<br>Новый пароль должен иметь длину не менее',
    user_temporary_locked: 'Невозможно авторизоваться.<br>Ваша учётная запись заблокирована из-за многократного неверного ввода логина/пароля.',
    user_locked_by_system: 'Невозможно авторизоваться.<br>Ваша учётная запись заблокирована, т.к. Вы не входили в систему более {0}.',
    users_exists_with_this_role: 'Невозможно удалить роль.<br>Существует пользователь с данной ролью.',
    duplicate_value_message_role: 'Невозможно сохранить роль.<br>Роль пользователя с таким именем уже существует.',
    transport_not_allowed_for_client: 'Транспорт не разрешён для данного клиента.',
    transport_cascading_not_allowed_for_client: 'Транспорт каскадирования не разрешён для данного клиента.',
    active_directory_not_set: 'Невозможно авторизоваться.<br>Не заданы настройки подключения Active Directory.',
    user_already_in_system: 'Невозможно авторизоваться.<br>Пользователь с таким логином уже есть в Системе.',
    unable_remove_default_user: 'Невозможно удалить пользователя по умолчанию.',
    unable_change_default_user: 'Невозможно изменить настройки пользователя по умолчанию.',
    have_not_permission_for_this_user: 'Невозможно отредактировать пользователя.<br>Недостаточно прав для редактирования данного пользователя.',
    unable_remove_default_role: 'Невозможно удалить роль по умолчанию.',
    unable_change_default_role: 'Невозможно изменить роль по умолчанию.',
    no_data_to_export: 'Невозможно выполнить экспорт.<br>Нет данных для экспорта.',
    no_data_to_show: 'Нет данных для отображения.',
    duplicate_preprocessing_rule: 'Невозможно сохранить сохранить правило препроцессинга.<br>Правило препроцессинга с такими настройками уже существует.',
    have_users_with_this_role: 'Существуют пользователи с данного ролью, перед удалением роли необходимо изменить их роль на новую.',
    unable_to_reset_category_transport: 'Невозможно изменить список транспортов для категории, поскольку у тарифов/тарифных зон следующих поставщиков не задана цена по умолчанию: ',
    tariff_zones_of_the_group_not_empty: 'Сначала необходимо удалить тарифные зоны группы',
    template_with_used_active_bulk: 'По этому шаблону производится рассылка',
    active_directory_server_unavaible: 'Невозможно авторизоваться. Сервер Active Directory недоступен',
    unable_set_ad_group: 'Невозможно указать группу пользователей Active Directory.<br>Данная группа уже задействована для другой роли',
    server_unavailable: 'Невозможно выполнить запрос. Сервер приложений недоступен',
    email_resend_failed_whithout_template: 'Сообщение было первоначально отправлено без шаблона, поэтому его невозможно отправить с вложениями (если они были). Вы хотите продолжить?',
    email_resend_failed_whithout_text: 'Невозможно переотправить сообщение. У сообщения нет текста письма. Возможно, отключено сохранение текста Email-сообщений',
    unable_edit_template: 'Невозможно изменить шаблон!<br> У шаблона есть черновик на модерации',
    invalid_distribution_status: 'Неверный статус рассылки',
    duplicate_template_name: 'Дублирующееся наименование',
    import_file_too_long: 'Невозможно импортировать файл. В импортируемом файле слишком много записей',
    system_setting_not_specified: 'Невозможно выполнить запрос. Не задана системная настройка {name}.',
    no_partner_user_found: 'Пользователя личного кабинета с такой электронной почтой нет в системе',
    change_password_limit: 'Превышено количество попыток смены пароля в течении заданного времени',
    invalid_import_file: 'Импорт невозможен.<br>Файл некорректен или указан неправильный разделитель.',
    regular_expression_not_allowed: 'Для использования в тексте элементов регулярных выражений, таких как: "[", "]", "{", "}", "\\", "+", "*", "%w", "%d", "^", "$", "|"; используйте вариант условия: "Удовлетворяет регулярному выражению',
    public_private_key_not_valid: 'Пара публичного и приватного ключей не валидна',

    syntax_error: 'Внутренняя ошибка сервера.',
    unable_data: 'Невозможно получить данные. Не заданы обязательные параметры: ',
    invalid_date_format: 'Неверный формат даты',
    invalid_date_interval: 'Невозможно получить данные. Некорректный интервал дат',
    forbidden: 'Невозможно получить данные. Доступ к странице не разрешён',
    transport_not_allowed: 'Невозможно получить данные. Транспорт не разрешён',
    unable_save_contact: 'Невозможно сохранить контакт. Контакт с такими данными уже существует в этом чёрном листе.',
    unable_save_template: 'Невозможно сохранить шаблон. Возможно зацикливание каскадной отправки в шаблоне с идентификатором {templateID} канала {transport}',
    viber_custom_content_validation: "Одно из полей 'Сообщение', 'Ссылка на изображение', 'Название кнопки', 'Ссылка на кнопку', 'Файл' должно быть заполнено",
    viber_button_requires_link_or_file: "Если заполнено поле 'Название кнопки', то одно из полей 'Ссылка на кнопку' или 'Файл' также должно быть заполнено"
  },

  dialog: {
    confirm: 'Сохранить изменения?',
    delete: 'Вы действительно хотите удалить запись?',
    error: 'Обнаружена ошибка',
    warning: 'ВНИМАНИЕ!',
    success: 'Операция успешно выполнена',
    export: 'Отчет успешно экспортирован',
    error_export: 'При экспорте произошла ошибка',
    resend: 'Сообщение будет переотправлено',
    not_selected_transport: 'Должен быть выбран хотя бы один транспорт',
    delete_all_default_category: '1. При назначении категории категорией по умолчанию все связанные с ней регулярные выражения для данного транспорта будут удалены.<br>\
    2. Если для данного транспорта уже задана категория по умолчанию, данный признак с неё будет снят, а для того чтобы её можно было применить к сообщениям, необходимо будет настроить регулярные выражения.<br>\
    3. Если у тарифа/тарифной зоны не было цены по умолчанию, а отменённая категория по умолчанию была единственной, по которой производилась тарификация, то отправка по данному направлению будет невозможна до тех пор, пока не будут настроены регулярные выражения.<br><br>\
    Вы действительно хотите продолжить?',
    delete_all_tarifzone: 'Будут удалены все связанные регулярные выражения и настройки тарифных зон'
  },

  pages: {
    Dashboard: 'Панель администратора',

    sms: 'SMS',
    sms_templates: 'Шаблоны',
    sms_templates_new: 'Создание шаблона',
    sms_templates_edit: 'Редактирование шаблона',
    sms_detail: 'Детальная статистика',
    sms_detail_info: 'Информация о сообщении',
    sms_group: 'Групповая статистика',
    sms_tarification_partners: 'Маршрутизация и тарификация клиентов',
    sms_tarification_partners_new: 'Создание тарифной зоны клиента',
    sms_tarification_partners_edit: 'Редактирование тарифной зоны клиента',
    sms_tarification_partners_group: 'Настройки группы тарифных зон клиента',
    sms_tarification_operators: 'Маршрутизация и тарификация поставщиков услуг',
    sms_tarification_operators_new: 'Создание тарифной зоны поставщика услуг',
    sms_tarification_operators_edit: 'Редактирование тарифной зоны поставщика услуг',
    sms_tarification_operators_group: 'Настройки группы тарифных зон поставщика услуг',
    sms_priority_rules:'Изменение приоритета SMS',
    sms_priority_rules_new: 'Создание правила приоритета SMS',
    sms_priority_rules_edit: 'Редактирование правила приоритета SMS',
    sms_originator_rules:'Изменение адреса отправителя SMS',
    sms_originator_rules_new: 'Создание правила изменения адреса отправителя SMS',
    sms_originator_rules_edit: 'Редактирование правила изменения адреса отправителя SMS',
    sms_filters: 'Блокировка по тексту SMS',
    sms_filters_new: 'Создание правила блокировки по тексту SMS',
    sms_filters_edit: 'Редактирование правила блокировки по тексту SMS',
    sms_incoming_tariffs: 'Маршрутизация входящих сообщений',
    sms_incoming_tariffs_new: 'Маршрутизация входящих сообщений',
    sms_incoming_tariffs_edit: 'Маршрутизация входящих сообщений',
    sms_group_incoming: 'Групповая статистика входящих SMS',
    sms_detail_incoming: 'Детальная статистика входящих SMS',
    sms_detail_incoming_info: 'Информация о сообщении',
    originator_restrictions: 'Ограничения адресов отправителей',
    originator_restrictions_new: 'Создание правила ограничения адресов отправителей',
    originator_restrictions_edit: 'Редактирование правила ограничения адресов отправителей',

    push: 'Push',
    push_detail: 'Детальная статистика',
    push_detail_info: 'Информация о сообщении',
    push_group: 'Групповая статистика',
    push_templates: 'Шаблоны',
    push_templates_new: 'Создание шаблона',
    push_templates_edit: 'Редактирование шаблона',
    attributes: 'Атрибуты приложений',
    attributes_new: 'Создание аттрибута приложения',
    attributes_edit: 'Редактирование атрибута приложения',
    push_applications: 'Управление приложениями',
    push_applications_new: 'Создание приложения',
    push_applications_edit: 'Редактирование приложения',
    push_groups_applications: 'Группы приложений',
    push_groups_applications_new: 'Создание группы приложений',
    push_groups_applications_edit: 'Редактирование группы приложений',
    push_subscribers: 'Количество подписчиков',
    push_history: 'История подписок',
    push_client_tariff: 'Тарификация Push клиентов',
    push_client_tariff_new: 'Создание тарификации Push клиентов',
    push_client_tariff_edit: 'Редактирование тарификации Push клиентов',

    call: 'Звонки',
    call_group_incoming: 'Групповая статистика входящих звонков',
    call_detail_incoming: 'Детальная статистика входящих звонков',
    call_detail_incoming_info: 'Информация о сообщении',
    call_detail: 'Детальная статистика',
    call_group: 'Групповая статистика',
    call_originator_rules: 'Изменение адреса отправителя Call',
    call_originator_rules_new: 'Создание правила изменения адреса отправителя Call',
    call_originator_rules_edit: 'Редактирование правила изменения адреса отправителя Call',

    email: 'Электронная почта',
    email_detail: 'Детальная статистика',
    email_detail_info: 'Информация о сообщении',
    email_group: 'Групповая статистика',
    email_templates: 'Шаблоны',
    email_templates_new: 'Создание шаблона',
    email_templates_edit: 'Редактирование шаблона',
    email_clients_tariff: 'Тарификация Email клиентов',
    email_clients_tariff_new: 'Создание тарификации Email клиентов',
    email_clients_tariff_edit: 'Редактирование тарификации Email клиентов',
    email_provider_tariff: 'Тарификация Email поставщиков услуг',
    email_provider_tariff_new: 'Создание тарификации Email поставщиков услуг',
    email_provider_tariff_edit: 'Редактирование тарификации Email поставщиков услуг',

    viber: 'Viber',
    viber_detail: 'Детальная статистика',
    viber_detail_info: 'Информация о сообщении',
    viber_group: 'Групповая статистика',
    viber_templates: 'Шаблоны',
    viber_templates_new: 'Создание шаблона',
    viber_templates_edit: 'Редактирование шаблона',
    viber_client_tariff: 'Тарификация Viber клиентов',
    viber_client_tariff_new: 'Создание тарификации Viber клиентов',
    viber_client_tariff_edit: 'Редактирование тарификации Viber клиентов',
    viber_provider_tariff: 'Тарификация Viber поставщиков услуг',
    viber_provider_tariff_new: 'Создание тарификации Viber поставщиков услуг',
    viber_provider_tariff_edit: 'Редактирование тарификации Viber поставщиков услуг',
    viber_incoming_tariffs: 'Маршрутизация входящих сообщений',
    viber_incoming_tariffs_new: 'Маршрутизация входящих сообщений',
    viber_incoming_tariffs_edit: 'Маршрутизация входящих сообщений',
    viber_detail_incoming: 'Детальная статистика входящих Viber',
    viber_detail_incoming_info: 'Информация о сообщении',
    viber_group_incoming: 'Групповая статистика входящих Viber',

    whatsapp: 'WhatsApp',
    whatsapp_detail: 'Детальная статистика',
    whatsapp_detail_info: 'Информация о сообщении',
    whatsapp_group: 'Групповая статистика',
    whatsapp_templates: 'Шаблоны',
    whatsapp_templates_new: 'Создание шаблона',
    whatsapp_templates_edit: 'Редактирование шаблона',
    whatsapp_client_tariff: 'Тарификация WhatsApp клиентов',
    whatsapp_client_tariff_new: 'Создание тарификации WhatsApp клиентов',
    whatsapp_client_tariff_edit: 'Редактирование тарификации WhatsApp клиентов',
    whatsapp_provider_tariff: 'Тарификация WhatsApp поставщиков услуг',
    whatsapp_provider_tariff_new: 'Создание тарификации WhatsApp поставщиков услуг',
    whatsapp_provider_tariff_edit: 'Редактирование тарификации WhatsApp поставщиков услуг',
    whatsapp_incoming_tariffs: 'Маршрутизация входящих сообщений',
    whatsapp_incoming_tariffs_new: 'Маршрутизация входящих сообщений',
    whatsapp_incoming_tariffs_edit: 'Маршрутизация входящих сообщений',
    whatsapp_detail_incoming: 'Детальная статистика входящих WhatsApp',
    whatsapp_detail_incoming_info: 'Информация о сообщении',
    whatsapp_group_incoming: 'Групповая статистика входящих WhatsApp',

    mail_notify: 'Mail Notify',
    mail_notify_templates: 'Шаблоны',
    mail_notify_templates_new: 'Создание шаблона',
    mail_notify_templates_edit: 'Редактирование шаблона',
    mail_notify_management_templates: 'Операторские шаблоны Mail Notify',
    mail_notify_management_templates_new: 'Создание Mail Notify шаблона',
    mail_notify_management_templates_edit: 'Редактирование Mail Notify шаблона',
    mail_notify_detail: 'Детальная статистика',
    mail_notify_detail_info: 'Информация о сообщении',
    mail_notify_group: 'Групповая статистика',
    mail_notify_client_tariff: 'Тарификация Mail Notify клиентов',
    mail_notify_client_tariff_new: 'Создание тарификации Mail Notify клиентов',
    mail_notify_client_tariff_edit: 'Редактирование тарификации Mail Notify клиентов',
    mail_notify_provider_tariff: 'Тарификация Mail Notify поставщиков услуг',
    mail_notify_provider_tariff_new: 'Создание тарификации Mail Notify поставщиков услуг',
    mail_notify_provider_tariff_edit: 'Редактирование тарификации Mail Notify поставщиков услуг',
    mail_notify_management_services: 'Операторские сервисы Mail Notify',
    mail_notify_management_services_new: 'Создание сервиса Mail Notify',
    mail_notify_management_services_edit: 'Редактирование сервиса Mail Notify',

    custom: 'Custom',
    custom_detail: 'Детальная статистика',
    custom_detail_info: 'Информация о сообщении',
    custom_group: 'Групповая статистика',
    custom_templates: 'Шаблоны',
    custom_templates_new: 'Создание шаблона',
    custom_templates_edit: 'Редактирование шаблона',
    custom_client_tariff: 'Тарификация Custom клиентов',
    custom_client_tariff_new: 'Создание тарификации Custom клиентов',
    custom_client_tariff_edit: 'Редактирование тарификации Custom клиентов',
    custom_provider_tariff: 'Тарификация Custom поставщиков услуг',
    custom_provider_tariff_new: 'Создание тарификации Custom поставщиков услуг',
    custom_provider_tariff_edit: 'Редактирование тарификации Custom поставщиков услуг',
    custom_detail_incoming: 'Детальная статистика входящих Custom',
    custom_detail_incoming_info: 'Информация о сообщении',
    custom_group_incoming: 'Групповая статистика входящих Custom',

    settings: 'Настройки',
    service_providers:'Поставщики услуг',
    service_providers_new:'Создание поставщика услуг',
    service_providers_edit:'Редактирование поставщика услуг',
    partners:'Клиенты',
    partners_new:'Создание клиента',
    partners_edit:'Редактирование клиента',
    accounts:'Аккаунты',
    accounts_new:'Создание аккаунта',
    accounts_edit:'Редактирование аккаунта',
    originators: 'Адреса отправителей',
    originators_new:'Создание адреса отправителя',
    originators_edit:'Редактирование адреса отправителя',
    system_settings: 'Настройки системы',
    system_settings_new: 'Создание настройки системы',
    system_settings_edit: 'Редактирование переменной',
    reports: 'Отчеты по экспорту',
    message_types: 'Типы сообщений',
    message_types_new: 'Создание типа сообщения',
    message_types_edit: 'Редактирование типа сообщения',
    message_categories: 'Категории сообщений',
    message_categories_new: 'Создание категории сообщений',
    message_categories_edit: 'Редактирование категории сообщений',
    message_categories_regexes:'Управление регулярными выражениями',
    message_categories_regexes_new:'Создание регулярного выражения',
    message_categories_regexes_edit:'Редактирование регулярного выражения',
    duplicates: 'Блокировка одинаковых сообщений',
    duplicates_new: 'Создание правила блокировки одинаковых сообщений',
    duplicates_edit: 'Редактирование правила блокировки одинаковых сообщений',
    quantity_limits: 'Ограничение количества отправляемых сообщений',
    quantity_limits_new: 'Создание правила ограничения количества отправляемых сообщений',
    quantity_limits_edit: 'Редактирование правила ограничения количества отправляемых сообщений',
    provider_connections: 'Подключения поставщиков услуг',
    partners_connections: 'Подключения клиентов',
    partners_connections_new: 'Создание подключения клиента',
    partners_connections_edit: 'Редактирование подключения клиента',
    smpp_connections: 'Подключения к операторам по SMPP',
    smpp_connections_new: 'Создание подключения к оператору по SMPP',
    smpp_connections_edit: 'Редактирование подключения к оператору по SMPP',
    preprocessing_rules: 'Препроцессинг',
    preprocessing_rules_new: 'Создание нового правила',
    preprocessing_rules_edit: 'Редактирование правила',
    black_lists: 'Черные списки',
    black_lists_new: 'Создание черного списка',
    black_lists_edit: 'Редактирование черного списка',
    black_list_contacts: 'Контакты черного списка',
    black_list_contacts_new: 'Создание контакта черного списка',
    black_list_contacts_edit: 'Редактирование контакта черного списка',
    black_list_generals: 'Общий чёрный список',
    black_list_generals_new: 'Создание контакта в общем чёрном списке',
    black_list_generals_edit: 'Редактирование контакта в общем чёрном списке',
    template_params: 'Параметры шаблона',
    template_params_new: 'Создание параметра шаблона',
    template_params_edit: 'Редактирование параметра шаблона',

    user_management: 'Управление пользователями',
    partner_users: 'Пользователи личного кабинета',
    partner_users_new: 'Создание нового пользователя',
    partner_users_edit: 'Редактирование пользователя',
    action_users: 'Действия пользователей',
    action_users_info: 'Подробная информация о действии пользователя',
    user_roles: 'Роли',
    user_roles_new: 'Создание роли',
    user_roles_edit: 'Редактирование роли',
    partner_user_roles: 'Роли пользователей личного кабинета',
    partner_user_roles_new: 'Создание роли пользователей личного кабинета',
    partner_user_roles_edit: 'Редактирование роли пользователей личного кабинета',
    system_users: 'Пользователи системы',
    system_users_new: 'Создание пользователя системы',
    system_users_edit: 'Редактирование пользователя системы',
    system_actions: 'Настройки логирования действий пользователей',
    system_actions_edit: 'Редактирование настройки логирования',

    templates_moderation: 'Модерация шаблонов',
    templates_moderation_edit: 'Модерация шаблона',
    distributions_moderation: 'Модерация рассылок',
    distributions_moderation_edit: 'Модерация рассылки',

    finance: 'Управление финансами',
    balances: 'История пополнений',
    overdrafts: 'Управление балансами',

    top_up_balance: 'Пополнение баланса',
    overdraft_settings: 'Настройки порога отключения',

    incoming_tariffs: 'Маршрутизация входящих сообщений',
    incoming_tariffs_new: 'Маршрутизация входящих сообщений',
    incoming_tariffs_edit: 'Маршрутизация входящих сообщений',
  },

  lang:{
    ru: 'Русский',
    en: 'English',
  },

  variable: {
    number: 'Номер',
    name: 'Имя',
    surname: 'Фамилия',
    patronymic: 'Отчество',
    field_1: 'Поле 1',
    field_2: 'Поле 2',
    field_3: 'Поле 3',
    field_4: 'Поле 4',
    field_5: 'Поле 5',
    field_6: 'Поле 6',
  },

  week_days: {
    MON: 'Понедельник',
    TUE: 'Вторник',
    WED: 'Среда',
    THU: 'Четверг',
    FRI: 'Пятница',
    SAT: 'Суббота',
    SUN: 'Воскресенье',
  },

  user_management: {
    system_actions:{
      user_action: 'Действия пользователей',
      fields:{
        create: 'Создание сущности',
        update: 'Изменение сущности',
        view: 'Просмотр страницы',
        delete: 'Удаление сущности',
        authorization: 'Авторизация пользователя',
        permission: 'Изменение прав доступа',
        topups: 'Пополнение баланса клиента',
      }
    }
  },

  charging: {
    sending: 'За отправку',
    delivery: 'За доставку'
  },

  routing: {
    name: 'Маршрутизация',
    msisdn: 'По префиксу MSISDN',
    'mcc/mnc': 'По MCC/MNC'
  },

  is_allowed: {
    name: 'Разрешена отправка',
    all: 'Через всех поставщиков услуг',
    allowed: 'Через разрешенных поставщиков услуг'
  },

  values: {
    priority: {
      2: 'Low',
      4: 'Normal',
      6: 'High',
      8: 'Realtime',
    },
    active: {
      all: 'Все',
      active: 'Активный',
      inactive: 'Неактивный',
      yes: 'Да',
      no: 'Нет',
      1: 'Активный',
      0: 'Неактивный',
    },
    message_status: {
      Failed: 'Ошибка',
      Rejected: 'Отклонено',
      NotDelivered: 'Не доставлено',
      Delivered: 'Доставлено',
      Deferred: 'Отложено',
      Expired: 'Просрочено',
      Transmitted: 'Отправлено',
      NotAnswered: 'Не отвечено',
      Buffered: 'Отложено',

      Read: 'Прочитано',
      Error: 'Ошибка',
      Processed: 'Обработано',
      Finished: 'Завершено',
    },
    sender_status: {
      ACCEPTED: 'Разрешен',
      UNDER_CONSIDERATION: 'На рассмотрении',
      DENIED: 'Запрещен',
    },
    report_status: {
      NEW: 'Новый',
      IN_PROCESS: 'В процессе',
      FINISHED: 'Сформирован',
      FAILED: 'Ошибка',
    },
    template_status: {
      ForModeration: 'Ожидает модерации',
      OnModeration: 'На модерации',
    },
    provider_connection_status: {
      1: 'Соединено',
      0: 'Не соединено',
    },
    date:{
      min: '5 мин',
      min_15: '15 мин',
      hour: '1 час',
      today: 'Сегодня',
      yesterday: 'Вчера',
      week: 'Неделя',
      month: 'Месяц',
    },
    group_by:{
      hour: 'Часу',
      day: 'Дню',
      week: 'Неделе',
      month: 'Месяцу',
      partner: 'Клиенту',
      service_provider: 'Поставщику услуг',
      originator: 'Отправителю',
      recipient_operator: 'Оператору',
      operator: 'Оператору',
      template_id: 'ID шаблона',
      bulk_id: 'ID рассылки',
      service_number: 'Входящему номеру',
      recipient: 'Сервисному номеру',
      originator_operator: 'Оператору',
      broker_account_login: 'Аккаунту',
      application: 'Приложению',
      platform: 'Платформе',
      message_category: 'Категории сообщения',
      message_type: 'Типу сообщения',
      mn_service_name: 'Сервису Mail Notify',
      mn_tmpl: 'Шаблону Mail Notify',
      os: 'Операционной системе',
      routes: 'Каналу',
    },
    devices_list: {
      ALL: 'Все',
      ONLY_LAST: 'Только последнее',
    },
    delimiter_list: {
      comma: 'Запятая',
      semicolon: 'Точка с запятой',
      space: 'Пробел',
    },
    mn_status: {
      0: 'На модерации',
      1: 'Подтвержден',
    },
    attribute_owner_list: {
      client: 'Подписчик',
      device: 'Устройство',
    },
    actions_status: {
      0: 'Не разрешено',
      1: 'Разрешено',
    },
    applications: {
      all: 'Все',
      last_created: 'Последнее созданное',
      by_priority: 'По приоритету'
    },
  },

  widget: {
    options: {
      update :'Частота обновления',
      interval: 'Временной интервал',
      chanel: 'Канал отправки',
      group_by: 'Группировка',
      direction: 'Направление отправки',
      track: 'Отслеживать',
      service_provider:'Поставщик услуг',
      statuses: 'Статусы',
      min: 'мин',
      no: 'Нет',
      hour: 'предыдущий час',
      today: 'сегодня',
      yesterday: 'вчера',
      more: 'еще',
      from: 'с',
      to: 'до',
    },
    channel: {
      SMS: 'SMS',
      Push: 'Push-уведомления',
      Viber: 'Viber-сообщения',
      Email: 'Email',
      Call: 'Звонки',
      WhatsApp: 'WhatsApp-сообщения',
    },
    statuses: {
      finished: 'Завершено',
      not_answered: 'Не отвечено',
      buffered: 'Отложено',
      error: 'Ошибка',
      read: 'Прочитано',
      transmitted: 'Передано',
      delivered: 'Доставлено',
      not_delivered: 'Не доставлено',
      expired: 'Просрочено',
      failed: 'Ошибка',
      rejected: 'Отклонено',
      deferred: 'Отложено',
    },
    WCSActivity: {
      name:'Активность WCS',
      title:'Активность WCS',
      status: {
        active: 'Все инстансы активны',
        inactive: 'Инстансы не активны',
      },
    },
    SMPPActivity: {
      name: 'Активность SMPP-подключений',
      title: 'Активность SMPP-подключений',
      partner: 'Входящие',
      service_provider: 'Исходящие',
      no_data: 'Нет соединений',
      status:{
        active: 'Все подключения активны',
        inactive: 'Нет активности коннектов',
      },
      options: {
        tracks: {
          all: 'все подключения',
          partner: 'только входящие (SMPP-аккаунты партнёров)',
          service_provider: 'только исходящие (SMPP-коннекты поставщиков услуг)',
        }
      },
    },
    ShippingSummary: {
      name: 'Сводная информация об отправке за период',
      title: 'с 14:00 до 15:00 отправлено',
    },
    MessageStatuses: {
      name: 'Статусы сообщений за период времени',
      title: 'Статусы сообщений',
    },
    MessagesByGroup: {
      name: 'Разбивка сообщений по группам',
      title: 'Сообщения по поставщикам',
      options: {
        group_by: {
          partner: 'по клиентам',
          service_provider: 'по поставщикам услуг',
          application: 'по приложению',
          os: 'по операционной системе',
        }
      }
    },
    TrafficSending: {
      name: 'График отправки трафика',
      title: 'График отправки сообщений с 01.06 по 02.06',
    },
    TrafficProviders: {
      name: 'Сравнение доставки трафика по поставщикам',
      title: 'Сравнение процента доставки ',
    },
    SendingProviders: {
      name: 'График отправки по поставщикам',
      title: 'График отправки',
    },
    ErrorsProviders: {
      name: 'Распределение ошибок по поставщикам',
      title: 'Распределение ошибок {chanel} по поставщикам',
    },
  },

  sms_filter:{
    eq: 'Равно',
    noteq: 'Не равно',
    in: 'Содержит',
    notin: 'Не содержит',
    is_regex: 'Удовлетворяет регулярному выражению'
  },

  restrictions: {
    alpha: 'Только буквенные',
    numeric: 'Только числовые',
    allowed: 'Заданные',
  },

  dates: {
    create_date: 'Дата создания',
    date: 'Дата',
    date_from: 'Дата с',
    date_to: 'Дата по',
    defer_date: 'Дата отложенной отправки',
    delivery_date: 'Дата доставки',
    deliver_date_from: 'Дата доставки с',
    deliver_date_to: 'Дата доставки по',
    edit_date: 'Дата редактирования',
    end_date: 'Дата завершения',
    end_date_from: 'Дата доставки с',
    end_date_to: 'Дата доставки по',
    event_date: 'Дата операции',
    read_date: 'Дата прочтения',
    sent_date: 'Дата отправки',
    sent_date_from: 'Дата отправки с',
    sent_date_to: 'Дата отправки по',
    start_date: 'Дата начала',
    start_date_from: 'Дата создания с',
    start_date_to: 'Дата создания по',
  },

  statuses: {
    buffered: 'Отложено',
    deferred: 'Отложено',
    delivered: 'Доставлено',
    duration: 'Длительность',
    error: 'Ошибка',
    expired: 'Просрочено',
    failed: 'Ошибка',
    finished: 'Завершено',
    not_answered: 'Не отвечено',
    not_delivered: 'Не доставлено',
    processed: 'Обработано',
    read: 'Прочитано',
    rejected: 'Отклонено',
    statuses: 'Статусы',
    transmitted: 'Отправлено',
  },

  descriptions: {
    deferred: 'Сообщения будут отправлены позже',
    delivered: 'Сообщения были доставлены до абонента',
    expired: 'Сообщения были переданы оператору, их срок жизни истек в очереди оператора',
    failed: 'При попытке отправки сообщения возникла ошибка',
    not_delivered: 'Сообщения не были доставлены до абонента. Финальный статус',
    read: 'Сообщения были прочитаны',
    rejected: 'Сообщения были отклонены платформой',
    total: 'Общее число сообщений',
    transmitted: 'Сообщения были переданы оператору, но статус о доставке еще не получен',
    partner_price: 'Цена клиента',
    provider_price: 'Цена поставщика услуг',
  },

  helps: {
    template_activity_html: 'Даты начала и окончания действия шаблона.<ul>' +
        '<li>Если дата начала не заполнена, то шаблон начнет действовать сразу. Если заполнена, то шаблон начнет действовать с заданной даты.</li>' +
        '<li>Если дата окончания не заполнена, то срок действия шаблона не ограничен. Если заполнена, то в заданную дату шаблон перестанет действовать.</li></ul>',
    template_timeout_html: '<ul><li>Текст для справки по таймауту шаблона</li></ul>',
    tariff_zones_group_settings: 'Пожалуйста настройте группу тарифных зон',
    tariff_zones_create: 'Создать новую тарифную зону',
    regex_condition: 'Условие используемое для проверки введенного текста, поддерживаются следующие варианты:\n' +
        'Равно - для проверки сообщения на полное соответствие введенному тексту в поле "Текст";\n' +
        'Не равно - для проверки сообщения на не соответствие введенному тексту в поле "Текст";\n' +
        'Содержит - для проверки сообщения на наличие в нем подстроки, введенной в поле "Текст";\n' +
        'Не содержит - для проверки сообщения на отсутствие в нем подстроки, введенной в поле "Текст";\n' +
        'Удовлетворяет регулярному выражению - для проверки сообщения на соответствие регулярному выражению, введенному в поле "Текст".'
  },

  symbols: {
    1: 'символ',
    2: 'символа',
    3: 'символов',
  },

  minutes: {
    1: 'минуту',
    2: 'минуты',
    3: 'минут',
  },

  days: {
    1: 'дня',
    2: 'дней',
    3: 'дней',
  }
};

export default messages;
